<template>
  <b-table
    ref="table"
    :items="outputs"
    :fields="fields"
    show-empty
    responsive
    class="mt-n2 loaded"
  >
    <template #cell(presetId)>
      <div />
    </template>
    <template #cell(name)="data">
      <a
        class="text-primary"
        @click="openOutput(data.index)"
      >{{
        data.value
      }}</a>
    </template>

    <template #cell(nameModifier)="data">
      <a
        class="text-primary"
        @click="openOutput(data.index)"
      >
        {{
          data.value ? data.value : isHLS || isDash ? '-' : data.item.name
        }}</a>
    </template>

    <template #cell(videoCodec)="data">
      {{ data.value || '-' }}
    </template>

    <template #cell(audioCodec)="data">
      {{ data.value || '-' }}
    </template>

    <template #empty>
      <div class="text-center py-1">
        <no-data
          no-data-text="No outputs created"
          create-text="Start by adding an output"
        />
      </div>
    </template>
  </b-table>
</template>

<script>
export default {
  name: 'OutputsTable',
  props: {
    outputs: {
      type: Array,
      default: () => [],
    },
    isHLS: {
      type: Boolean,
      required: true,
    },
    isDash: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      fieldsData: [
        { key: 'presetId', label: '' },
        { key: 'name', label: 'Folder Name' },
        { key: 'nameModifier', label: 'File Name' },
        { key: 'videoCodec', label: 'video' },
        { key: 'audioCodec', label: 'audio' },
        { key: 'presetId', label: '' },
        { key: 'id', label: '' },
      ],
    }
  },
  computed: {
    fields() {
      return this.isHLS || this.isDash
        ? this.fieldsData
        : this.fieldsData.filter(field => field.key !== 'name')
    },
  },
  methods: {
    openOutput(index) {
      this.$emit('editOutput', index)
    },
  },
}
</script>

<style></style>
